"use client";

import { c as _c } from "react/compiler-runtime";
import { IconSearch } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { useSearchPanelStore } from "@/stores/useSearchPanelStore";
export function SearchTrigger() {
  const $ = _c(5);
  const setOpen = useSearchPanelStore(_temp);
  let t0;
  if ($[0] !== setOpen) {
    t0 = () => setOpen(true);
    $[0] = setOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconSearch className="size-5" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Button variant="ghost" size="icon" aria-label="Open search" onClick={t0}>{t1}</Button>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(state) {
  return state.setOpen;
}